export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M8 58V34C8 19.5 18.7 8 32 8s24 11.5 24 26v24H8z" fill="currentColor" />
    <g fill="#F9F6F0">
      <circle cx="22.5" cy="33" r="4" />
      <circle cx="29" cy="28.5" r="4.3" />
      <circle cx="35.5" cy="28.5" r="4.3" />
      <circle cx="42" cy="33" r="4" />
      <path d="M32 34c5 0 9 3.6 9 8.2 0 3.4-2.8 5.8-6.2 5.8-1 0-1.9-.2-2.8-.6-.9.4-1.8.6-2.8.6-3.4 0-6.2-2.4-6.2-5.8C23 37.6 27 34 32 34z" />
    </g>
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark className={`h-9 w-9 ${dark ? "text-cream" : "text-forest"}`} />
    <span className="leading-none text-left">
      <span className={`block font-display text-[19px] font-semibold tracking-tight sm:text-[22px] ${dark ? "text-cream" : "text-ink"}`}>
        Ari&apos;s Happy Tails
      </span>
      <span className="mt-1 hidden font-mono text-[9px] uppercase tracking-[0.34em] text-marmalade sm:block">Pet Sitting · By Ari</span>
    </span>
  </span>
);

export default Logo;
